export const AppCat = 'taxi';